import { GraphQL } from "@graphql/graphQL";
import { UpdateApplianceMutation, UpdateApplianceMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultUpdateApplianceOptions: MutationHookOptions<UpdateApplianceMutation, UpdateApplianceMutationVariables> = {

};

export const useUpdateAppliance = (options?: MutationHookOptions<UpdateApplianceMutation, UpdateApplianceMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: UpdateApplianceMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<UpdateApplianceMutation, UpdateApplianceMutationVariables>(GraphQL.updateAppliance);

    const updateAppliance = async (variables: UpdateApplianceMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultUpdateApplianceOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data
            };
        } catch (error) {

            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        updateAppliance
    };
};
